<template>
  <div class="irons-banner-main">
    <h2 class="irons-banner-main__title">Для железных таксопарков</h2>
    <p class="irons-banner-main__description">
      Контролируйте ТО автомобилей, штрафы, платные дороги. Принимайте оплату за
      аренду с эквайрингом от 0,9% в ТА Парк
    </p>
    <a
      href="https://www.ta-park.ru/trial"
      target="_blank"
      class="irons-banner-main__btn"
      >Подключить таксопарк</a
    >
  </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";

@Component()
export default class IronsBannerMain extends Vue {}
</script>

<style lang="scss" scoped>
.irons-banner-main {
  padding: 47px 0 47px 60px;
  border-radius: 28px;
  margin-bottom: 95px;
  background: url("@/assets/img/ironBannerMain.png"),
    linear-gradient(90deg, #543187 0%, #7e32e6 100%);
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: auto, auto;

  &__title {
    font-family: "GTAmericaBold", "Roboto Condensed Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 74px;
    line-height: 100px;
    text-transform: uppercase;
    color: #fff;
    text-align: left;
  }

  &__description {
    max-width: 700px;
    margin-top: 32px;

    font-family: "GTAmericaEx", "Roboto Medium";
    font-style: normal;
    font-weight: 500;
    font-size: 42px;
    line-height: 46px;
    color: #fff;
    text-align: left;
  }

  &__btn {
    z-index: 500;
    display: block;
    padding: 23px 0;
    margin-top: 67px;
    max-width: 262px;
    text-decoration: none;

    font-family: "Roboto";
    font-style: normal;
    font-size: 16px;

    background: #40256b;
    border-radius: 6px;
    color: #fff;

    background: #a562ff;
    margin-right: auto;
    margin-left: 8px;

    &:hover {
      background: #e2dffa;
      color: #000;
    }
  }

  @media (max-width: 600px) {
    padding: 20px 17px 20px 17px;
    margin-bottom: 32px;
    background: url("@/assets/img/ironBannerMainMobile.png"),
      linear-gradient(90deg, #543187 0%, #7e32e6 100%);
    background-repeat: no-repeat;
    background-position: bottom right;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__title {
      max-width: 275px;
      font-size: 46px;
      line-height: 53px;
    }

    &__description {
      max-width: 275px;

      max-width: 700px;
      margin-top: 18px;

      font-size: 24px;
      line-height: 31px;
    }

    &__btn {
      margin: 0;
      margin-top: 185px;
      padding: 14px 0;
      width: 100%;
      max-width: initial;
    }
  }
}
</style>
